<!-- Editable list of a plan's or theme's goals, one curriculum at a time. Subgoals sit
     under their parent; they cannot be removed on their own (they travel with the
     parent) but can be muted — left out of this lesson — with the checkbox. -->
<template>
	<ul class="flex flex-col gap-4 py-6">
		<li
			v-for="goal in rows"
			:key="goal.id || goal.sourceId || goal.fullPath"
			class="flex gap-2 items-start"
			:class="[
				goal.isSubgoal() ? 'pl-6 text-sm' : '',
				goal.isSubgoal() && goal.muted ? 'opacity-40' : '',
			]"
		>
			<MapPinIcon
				class="shrink-0"
				:class="[goal.isSubgoal() ? 'mt-1 w-3 h-3' : 'mt-0.5 w-4 h-4']"
				:style="{ color: goal.color ?? '#86efac' }"
			/>
			<span
				class="text-base-content-light mr-2 shrink-0 w-24 overflow-hidden whitespace-nowrap text-ellipsis"
				:title="goal.fullPath"
				>{{ goal.fullPath }}</span
			>
			<span>
				<GoalTitle :goal="goal" titleClasses="whitespace-pre-wrap" />
				<GoalInfoDropdown v-if="goal.info" :info="goal.info" />
			</span>
			<div class="grow text-right pl-4">
				<input
					v-if="goal.isSubgoal()"
					type="checkbox"
					class="checkbox checkbox-sm"
					:checked="!goal.muted"
					:title="$t('Included')"
					:aria-label="$t('Included')"
					@change="$emit('goalMuteToggled', goal)"
				/>
				<button
					v-else
					type="button"
					class="btn btn-sm btn-ghost btn-circle bg-base-100"
					@click="$emit('goalUnselected', goal)"
				>
					<TrashIcon class="w-4 h-4"></TrashIcon>
				</button>
			</div>
		</li>
	</ul>
</template>

<script lang="ts">
import { MapPinIcon } from "@heroicons/vue/24/solid";
import { TrashIcon } from "@heroicons/vue/24/outline";
import GoalTitle from "@/components/GoalTitle.vue";
import GoalInfoDropdown from "@/components/GoalInfoDropdown.vue";
import { Goal } from "@/models/Goal.model";
import { groupSubgoalsUnderParents } from "@/goals/utils/SubgoalRows.util";

export default {
	emits: ['goalUnselected', 'goalMuteToggled'],

	components: {
		MapPinIcon,
		TrashIcon,
		GoalTitle,
		GoalInfoDropdown,
	},

	props: {
		goals: {
			type: Array,
			required: true,
		},
	},

	computed: {
		rows(): Goal[] {
			return groupSubgoalsUnderParents(this.goals as Goal[]);
		},
	},
};
</script>
